var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CampTab',{attrs:{"index":_vm.index},on:{"tap":_vm.tapFn}}),(_vm.index === 0)?_c('SpbcnWinnerCamp'):_c('National')],1)}
var staticRenderFns = []

export { render, staticRenderFns }